import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import { TemplateCard } from "./template-card/template-card";
import { BlankCanvasId, CanvasTemplateMinimal } from "shared/datamodel/schemas/canvas-template";
import style from "../../templates-modal.module.css";
import type { TemplatesSection } from "../../templates-modal";

interface TemplateSectionListProps {
  sections: TemplatesSection[];
  searchTerm: string;
  isCimReorderEnabled: boolean;
  syncedTemplatesSectionId: number;
  onTemplateClick: (template: CanvasTemplateMinimal) => void;
  onPreviewTemplate: (template: CanvasTemplateMinimal) => void;
  onSeeAllClick: (tagId: number, tagName: string) => void;
  onEditTemplate: (template: CanvasTemplateMinimal) => void;
  onDeleteTemplate: (templateId: string) => void;
}

export function TemplateSectionList({
  sections,
  searchTerm,
  isCimReorderEnabled,
  syncedTemplatesSectionId,
  onTemplateClick,
  onPreviewTemplate,
  onSeeAllClick,
  onEditTemplate,
  onDeleteTemplate,
}: TemplateSectionListProps) {
  if (sections.length === 0) {
    return (
      <Skeleton
        count={isCimReorderEnabled ? 4 : 3}
        containerClassName={style.templateSkeletonContainer}
        className={style.templateSkeleton}
      />
    );
  }

  return (
    <>
      {sections.map((section) => {
        const { id, title, templates, showSeeAll = false } = section;
        let spacer = null;
        if (templates.length % 3 > 0) {
          spacer = <div className={style.templateSpacer} />;
        }
        return (
          <div key={id} className={style.templatesSection}>
            {!searchTerm && (
              <>
                <div className={style.sectionHeader}>
                  <span className={style.sectionTitle}>{title}</span>
                  {showSeeAll && (
                    <span className={style.seeAll} onClick={() => onSeeAllClick(id, "See all")}>
                      See all
                    </span>
                  )}
                </div>
                {id === syncedTemplatesSectionId && (
                  <div className={style.sectionSubtitle}>
                    Create an integrated canvas and monday board—ready to use, built to sync.
                  </div>
                )}
              </>
            )}
            <div className={classNames(style.templates, { [style.templatesCIMFooterEnabled]: isCimReorderEnabled })}>
              {templates.map((template, index) => (
                <TemplateCard
                  key={index}
                  template={template}
                  previewAvailable={template.id !== BlankCanvasId}
                  onClick={onTemplateClick}
                  onPreview={(template) => onPreviewTemplate(template)}
                  onEditTemplate={(template) => {
                    onEditTemplate(template);
                  }}
                  onDeleteTemplate={() => {
                    onDeleteTemplate(template.id);
                  }}
                />
              ))}
              {spacer}
            </div>
          </div>
        );
      })}
    </>
  );
}
